module.exports = __webpack_public_path__ + "assets/img/qrcode.a633a589.jpg";